var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { AnimationService } from 'src/app/engine/animation.service';
import { Store, Select } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { filter, throttleTime, takeUntil } from 'rxjs/operators';
import { EngineService, EngineEventsEnum } from 'src/app/engine/engine.service';
import { TimerangeModel } from 'src/app/engine/models/animation/timerange.model';
import { EngineState } from '../../state/engine.state';
import { PlayAnimation } from '../../state/engine.actions';
var EngineScrubberComponent = /** @class */ (function () {
    function EngineScrubberComponent(changeDetection, animationService, store, engineService) {
        this.changeDetection = changeDetection;
        this.animationService = animationService;
        this.store = store;
        this.engineService = engineService;
        this.theme = 'dark';
        this.showPlay = true;
        this.showScrubber = true;
        this.playing = false;
        this.wasPlaying = false;
        this.ngUnsubscribe = new Subject();
        this._percent = 0;
        this.scrub$ = new BehaviorSubject(0);
        this.interactive = false;
        this.timeline = new TimerangeModel();
    }
    Object.defineProperty(EngineScrubberComponent.prototype, "percent", {
        get: function () {
            return this._percent;
        },
        set: function (value) {
            this._percent = value;
            var isPlaying = this.store.selectSnapshot(EngineState.getAnimationPlaying);
            if (!isPlaying) {
                this.scrubPercent(this.percent);
            }
        },
        enumerable: true,
        configurable: true
    });
    EngineScrubberComponent.prototype.ngOnInit = function () {
        this.bindApplicationEvents();
    };
    EngineScrubberComponent.prototype.ngOnDestroy = function () {
        this.changeDetection.detach();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.unsubscribe();
    };
    EngineScrubberComponent.prototype.bindApplicationEvents = function () {
        var _this = this;
        // Listen for ready state
        this.selectedChapter$.pipe(filter(function (chapter) { return chapter != null; }), takeUntil(this.ngUnsubscribe)).subscribe(function (chapter) {
            _this.interactive = chapter.readyState.model;
            _this.percent = 0;
            _this.changeDetection.markForCheck();
        });
        // Update scrubber on chapter change
        this.selectedChapterId$
            .pipe(filter(function (chapterId) { return !!chapterId; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (chapterId) {
            _this.initScrubber(chapterId);
        });
        // Listen to timeline ticks
        this.engineService.getEvent(EngineEventsEnum.TimelinePlaying)
            .pipe(throttleTime(50), takeUntil(this.ngUnsubscribe))
            .subscribe(function (event) { return _this.tick(event.time); });
        this.animationPlaying$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (playing) { return _this.playing = playing; });
    };
    EngineScrubberComponent.prototype.handleInputMouseDown = function () {
        this.wasPlaying = this.playing;
        this.store.dispatch(new PlayAnimation(false));
    };
    EngineScrubberComponent.prototype.handleInputMouseUp = function () {
        this.store.dispatch(new PlayAnimation(this.wasPlaying));
    };
    EngineScrubberComponent.prototype.handlePlayClick = function () {
        this.play();
    };
    EngineScrubberComponent.prototype.play = function () {
        var playing = !this.store.selectSnapshot(EngineState.getAnimationPlaying);
        this.store.dispatch(new PlayAnimation(playing));
    };
    EngineScrubberComponent.prototype.initScrubber = function (chapterId) {
        this.timeline = this.animationService.getChapterLocalTimerange(chapterId);
        this.percent = 0;
    };
    EngineScrubberComponent.prototype.tick = function (time) {
        var timerange = this.animationService.getChapterLocalTimerange(this.store.selectSnapshot(StoryChaptersState.getSelectedChapterId));
        var localTime = this.animationService.mapGlobalTimeToLocal(time);
        this.percent = (localTime / timerange.lastTime) * 100;
        this.changeDetection.markForCheck();
    };
    EngineScrubberComponent.prototype.scrubPercent = function (percent) {
        var localTime = (percent / 100) * this.timeline.lastTime;
        var which = 'first';
        if (percent === 0) {
            which = 'second';
        }
        if (percent === 100) {
            which = 'first';
        }
        var activeChapterId = this.store.selectSnapshot(StoryChaptersState.getSelectedChapterId);
        var globalTime = this.animationService.mapLocalTimeToGlobal(activeChapterId, localTime);
        this.animationService.scrub(globalTime, which);
    };
    __decorate([
        Select(StoryChaptersState.getSelectedChapterId),
        __metadata("design:type", Observable)
    ], EngineScrubberComponent.prototype, "selectedChapterId$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], EngineScrubberComponent.prototype, "selectedChapter$", void 0);
    __decorate([
        Select(EngineState.getAnimationPlaying),
        __metadata("design:type", Observable)
    ], EngineScrubberComponent.prototype, "animationPlaying$", void 0);
    return EngineScrubberComponent;
}());
export { EngineScrubberComponent };
